export abstract class SerializableValue {
}
